module.exports = __webpack_public_path__ + "img/alibanner.dbc09022.png";